
import  { ReactComponent as IconDelete }        from '../../assets/Icons/icon-delete.svg'
import  { ReactComponent as IconEdit }          from '../../assets/Icons/icon-edit.svg'
import '../../styles/Table.css';
import '../../styles/main.css';
import '../../styles/MassBalance.css'

import { formatFloatOneDecimal, formatDate } from '../../utils/stylesUtils.js';
import api                                      from '../../services/api.js';


function MassBalanceTable({tableRows}) {



   return (
        <>
            {/* {JSON.stringify(tableRows)} */}

            {tableRows.length > 0 ? (

                <table className="table-pattern-sistem w-[100%] borda-cinza">

                    <thead className="bg-azul-profundo-m text-white">
                        <tr>
                            <th className="!text-center">ID</th>
                            <th className="!text-center">Data</th>
                            <th className="!text-center">Terminal</th>
                            <th className="!text-center">Produto</th>
                            <th className="!text-center">Navio</th>
                            <th className="!text-center">Horas Disponíveis</th>
                            <th className="!text-center">Marítimo</th>
                            <th className="!text-center">Volume Rodoviário</th>
                            <th className="!text-center">Volume Ferroviário</th>
                            <th className="!text-center">Inicial</th>
                            <th className="!text-center">Final</th>
                            <th className="!text-center">Estática</th>
                        </tr>
                    </thead>

                    <tbody> 
                        {tableRows.map((row, index) => (
                            <tr key={index}>
                                <td className="!text-center">{row.id}</td>
                                <td className="!text-center">{formatDate(row.date)}</td>
                                <td className="!text-center">{row.ownerTerminal?.name}</td>
                                <td className="!text-center">{row.ownerProduct?.name}</td>
                                <td className="!text-center">{row.ship}</td>
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.operation)}</td> {/* ANTIGO ENTRADA */}
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.maritime)}</td>
                                <td className="!text-right !px-4" >{formatFloatOneDecimal(row.railway)}</td>
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.road)}</td>
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.initial)}</td>
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.final)}</td> 
                                <td className="!text-right !px-4">{formatFloatOneDecimal(row.static)}</td>

                            </tr>
                        ))}
                    </tbody>
                    <tfoot style={{backgroundColor: '#b6b6b654'}}>
                        <tr>
                            <td className="!text-center ">Total:</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.operation, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.maritime, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.railway, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.road, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.initial, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.final, 0))}</td>
                            <td className="!text-right !py-2 !px-4">{formatFloatOneDecimal(tableRows.reduce((acc, row) => acc + row.static, 0))}</td>
                        </tr>
                    </tfoot>
                </table>

            ) : (
                <p>Nenhum dado encontrado.</p>
            )}
        </>
    )
}

export default MassBalanceTable